import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Pages/Header";
import Home from "./Pages/Home";
import Menu from "./Pages/Menu";
import PopUp from './Pages/Popupeventpage'
import CateringServicePage from "./Pages/CateringServicePage";
import Contact from "./Components/Contact";
import Footer from "./Pages/Footer";
import AboutPage from "./Pages/About";

function App() {
  return (
    <Router>
    <Header />
    <Routes>
    <Route path="/" element={<Home />} />
    <Route path="menu" element={<Menu />} />
    <Route path="about" element={<AboutPage />} />
    <Route path="popup" element={<PopUp />} />
    <Route path="catering" element={<CateringServicePage />} />
    <Route path="/contact" element={<Contact />} />
    
    </Routes>
    <Footer />
    </Router>
  );
}

export default App;
